import { memo, type FC } from 'react';
import { Link } from '@compat/router';
import { Picture } from '@ui';
import './index.scss';

interface EmptyBannerProps {
  img:
    | string
    | {
        x1: string;
        x2: string;
        x3: string;
      };
  height?: string | number;
  title: string;
  btnText?: string;
  description?: string;
  link: string;
}

const EmptyBanner: FC<EmptyBannerProps> = ({
  img,
  height,
  title,
  btnText,
  description,
  link
}) => (
  <div className='empty-container'>
    <Picture icon={img} height={height || '95px'} />
    <span className='title'>{title}</span>
    {description && <span className='description'>{description}</span>}
    {btnText && (
      <Link className='grey-button' to={link}>
        {btnText}
      </Link>
    )}
  </div>
);

export default memo(EmptyBanner);
